import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { formatAmount } from "../../../utility/CommonFunctions";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import MainHeading from "../../../components/comman/MainHeading";
import { Fade, Nav, NavLink, NavItem, TabContent, TabPane } from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import {
  saveActivePurchaseOrderTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";

export default function PurchaseOrder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timeoutId = useRef(null);
  const userDetails = useSelector((state) => state.root.userDetails);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector((state) => state?.root?.activePurchaseOrderTab);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    purchaseData: [],
    pendingPurchaseData: [],
    searchQuery: "",
    status:
      ActiveTab == 1
        ? "created"
        : ActiveTab == 2
          ? "approved"
          : ActiveTab == 3
            ? "closed"
            : ActiveTab == 4
              ? "rejected"
              : userDetails?.department?.name === "Account" || userDetails?.designation?.name === "Director"
                ? "created"
                : "approved",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });

  const toggleTab = (tab) => {
    dispatch(saveActivePurchaseOrderTab(tab));
    setPageStates((prev) => ({
      ...prev,
      status:
        tab == 1
          ? "created"
          : tab == 2
            ? "approved"
            : tab == 3
              ? "closed"
              : tab == 4
                ? "rejected"
                : "",
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        pageSize: 10,
      })
    );
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  useEffect(() => {
    GetCompanyList();
  }, []);

  useEffect(() => {
    if (filterDetails?.year) {
      GetPurchaseList();
    }
    if (pageStates?.siteList?.length === 0) {
      GetSiteList();
    }
  }, [
    filterDetails?.currentPage,
    pageStates?.searchQuery,
    pageStates?.status,
    filterDetails.pageSize,
    filterDetails.sortByDate,
    filterDetails?.year,
    filterDetails?.siteId,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  const GetPurchaseList = () => {
    let options = {
      method: "GET",
    };
    const finalFilterData = {
      ...filterDetails,
      status: pageStates?.status,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
    };
    let API = apiUrl.get_purchase + MainFilterHandler(finalFilterData);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.purchase?.map((item) => ({
          ...item,
          prNumber: item?.purchaserequest?.requestNumber,
          date: moment(item?.purchaseDate).format("DD-MM-YYYY"),
          siteName: item?.purchaserequest?.site?.name,
          vendorName: item?.vendor?.name,
          totalAmounts: formatAmount(item?.totalAmount),
          purchaseRequestStatus: item?.status,
          reqType:
            item?.purchaserequest?.type === "supplyRequest"
              ? "Supply Request"
              : "Service Request",
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          purchaseData: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: response?.data?.pageInfo?.total,
            totalPages: response?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        pageSize: value,
      })
    );
  };

  const handleSearchChange = (e) => {
    // console.log("e", e.target.value);
    const { value } = e.target;

    console.log("valueee", value);
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  // const ActionHandler = (data) => {
  //   setSelectedId(data?.id);
  //   toggle();
  // };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_purchase, {
      state: { data: data, type: "Create" },
    });
  };

  const HandleEdit = (data) => {
    navigate(RoutesLink?.create_purchase, {
      state: { data: data, type: "Edit" },
    });
  };

  // const HandleDelete = () => {
  //   let options = {
  //     method: "GET",
  //   };
  //   let API = apiUrl.delete_customer + `?customerId=${selectedId}`;
  //   setIsLoading(true);
  //   callApi(API, options).then((response) => {
  //     setIsLoading(false);
  //     if (response?.status === true) {
  //       toast.success(response?.message);
  //       toggle();
  //       GetCustomerList(pageStates?.currentPage);
  //     } else {
  //       toast.error(response?.message);
  //       toggle();
  //     }
  //   });
  // };

  const HandleView = (data) => {
    navigate(RoutesLink.purchase_order_detail + `/${data?.id}`, {
      state: { data: data },
    });
  };

  const TableHeading = [
    { value: "purchaseNumber", label: "PO No." },
    { value: "prNumber", label: "PR No." },
    { value: "date", label: "Date" },
    { value: "siteName", label: "Site Name" },
    { value: "vendorName", label: "Vendor" },
    { value: "reqType", label: "Type" },
    { value: "totalAmounts", label: "Total Amount" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];
  // const TableHeadingPurchase = [
  //   { value: "purchaseNumber", label: "PR No." },
  //   { value: "date", label: "Date" },
  //   { value: "siteName", label: "Site Name" },
  //   { value: "vendorName", label: "Vendor" },
  //   { value: "reqType", label: "Type" },
  //   { value: "totalAmounts", label: "Total Amount" },
  //   { value: "purchaseRequestStatus", label: "Status" },
  // ];


  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );
    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Purchase Order"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        {(userDetails?.department?.name === "Account" || userDetails?.designation?.name === "Director") && (
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.status === "created"
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0  border-end-1 border-start-1 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-1 border-start-1"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(1)}
              >
                Pending
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.status === "approved"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-1 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(2)}
              >
                Approved
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.status === "closed"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(3)}
              >
                Short Closed
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  pageStates?.status === "rejected"
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(4)}
              >
                Rejected
              </NavLink>
            </NavItem>
          </Nav>
        )}

        <TabContent activeTab={pageStates?.status}>
          <TabPane tabId={"created"}>
            <Fade in={pageStates?.status === "created"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    exportBtn={true}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.purchaseData}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    pageSize={filterDetails.pageSize}
                    handleChangePageSize={handleChangePageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"approved"}>
            <Fade in={pageStates?.status === "approved"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    exportBtn={true}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.purchaseData}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    pageSize={filterDetails.pageSize}
                    handleChangePageSize={handleChangePageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"closed"}>
            <Fade in={pageStates?.status === "closed"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    exportBtn={true}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.purchaseData}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    pageSize={filterDetails.pageSize}
                    handleChangePageSize={handleChangePageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"rejected"}>
            <Fade in={pageStates?.status === "rejected"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    exportBtn={true}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeading}
                    TableData={pageStates?.purchaseData}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    pageSize={filterDetails.pageSize}
                    handleChangePageSize={handleChangePageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
}
